
import { MessageBox } from 'element-ui';
export default function(obj){
    // alert(obj.params)
    MessageBox(obj.params)
}